// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YC2h_{display:flex;gap:8px;flex-direction:column;padding-top:16px;width:400px}.vQZ51{width:278px}.pdEPa{padding-left:8px}.qhqht{width:278px;display:flex;gap:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `YC2h_`,
	"menuItem": `vQZ51`,
	"noServices": `pdEPa`,
	"subtitle": `qhqht`
};
export default ___CSS_LOADER_EXPORT___;
